var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.1802 10.7964C52.4215 10.7964 53.4276 11.8025 53.4276 13.0435V59.1416C53.4276 60.3658 52.435 61.3582 51.2107 61.3582C44.3181 61.3582 23.3084 61.3582 16.3597 61.3582C15.7608 61.3582 15.1864 61.1203 14.763 60.697C14.3394 60.2733 14.1016 59.6989 14.1016 59.1003C14.1016 50.8189 14.1016 22.5941 14.1016 22.5941C17.5044 25.0516 20.6576 25.1384 23.6522 23.7178C21.9048 19.3256 22.0852 15.4152 24.6955 12.1123C25.3349 11.2996 26.3119 10.825 27.3461 10.825C31.8613 10.7964 45.7179 10.7964 51.1802 10.7964Z",
    fill: "url(#paint0_linear_113_4109)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.7435 10.6741L51.1255 10.6738C52.3665 10.6738 53.3726 11.6799 53.3726 12.9212V59.019C53.3726 60.2433 52.3803 61.2356 51.156 61.2356C44.2631 61.2356 23.2537 61.2356 16.3048 61.2356C15.7061 61.2356 15.1317 60.9978 14.7081 60.5744C14.2847 60.1508 14.0469 59.5767 14.0469 58.9777V56.304C14.3413 57.2136 15.1954 57.8648 16.195 57.8648H48.9086C50.1329 57.8648 51.1255 56.8725 51.1255 55.6482C51.1255 47.6713 51.1255 20.492 51.1255 12.7483C51.1255 11.8196 50.5598 11.0144 49.7435 10.6741Z",
    fill: "url(#paint1_linear_113_4109)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5975 23.5954C22.5669 25.4563 17.529 27.516 14.0469 25.5887V22.4717C14.0469 22.4717 19.7721 23.6008 23.5975 23.5954Z",
    fill: "#B4E0C2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.6455 10.9004C21.7408 11.9979 15.5488 17.9413 14.1016 22.5938C17.5044 25.0512 20.6576 25.1381 23.6522 23.7175C21.9048 19.3252 22.0852 15.4148 24.6955 12.112C25.3349 11.2992 25.9551 11.0854 26.6455 10.9004Z",
    fill: "#34C099"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.8644 33.5286C57.8644 32.9189 57.6223 32.334 57.1911 31.9028C56.7599 31.4716 56.175 31.2295 55.5653 31.2295C49.9272 31.2295 35.4649 31.2295 29.8268 31.2295C29.2168 31.2295 28.6322 31.4716 28.201 31.9028C27.7698 32.334 27.5273 32.9189 27.5273 33.5286V53.3187C27.5273 53.9284 27.7698 54.5133 28.201 54.9445C28.6322 55.3757 29.2168 55.6178 29.8268 55.6178H55.5653C56.175 55.6178 56.7599 55.3757 57.1911 54.9445C57.6223 54.5133 57.8644 53.9284 57.8644 53.3187C57.8644 48.6656 57.8644 38.1817 57.8644 33.5286Z",
    fill: "url(#paint2_linear_113_4109)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.0322 32.5801C54.9564 32.8813 55.6173 33.7496 55.6173 34.766V49.9477C55.6173 50.5574 55.3752 51.1423 54.944 51.5735C54.5128 52.0047 53.9279 52.2469 53.3182 52.2469C48.0045 52.2469 34.9296 52.2469 29.7208 52.2469C28.6958 52.2469 27.8218 51.5746 27.5273 50.6389V53.3185C27.5273 53.9282 27.7698 54.5131 28.201 54.9443C28.6322 55.3755 29.2168 55.6177 29.8268 55.6177H55.5653C56.175 55.6177 56.7599 55.3755 57.1911 54.9443C57.6223 54.5131 57.8644 53.9282 57.8644 53.3185C57.8644 48.9049 57.8644 39.2928 57.8644 34.8792C57.8644 34.2695 57.6223 33.6846 57.1911 33.2534C56.7599 32.8222 56.175 32.5801 55.5653 32.5801H54.0322Z",
    fill: "#FFE283"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.5273 37.5426H57.8644V33.5286C57.8644 32.9189 57.6223 32.334 57.1911 31.9028C56.7599 31.4716 56.175 31.2295 55.5653 31.2295C49.9272 31.2295 35.4649 31.2295 29.8268 31.2295C29.2168 31.2295 28.6322 31.4716 28.201 31.9028C27.7698 32.334 27.5273 32.9189 27.5273 33.5286V37.5426Z",
    fill: "#EB6041"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.5273 37.5426H55.6173V33.5286C55.6173 32.9189 55.3752 32.334 54.944 31.9028C54.5128 31.4716 53.9279 31.2295 53.3182 31.2295C47.6798 31.2295 35.4649 31.2295 29.8268 31.2295C29.2168 31.2295 28.6322 31.4716 28.201 31.9028C27.7698 32.334 27.5273 32.9189 27.5273 33.5286V37.5426Z",
    fill: "url(#paint3_linear_113_4109)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.4829 50.4855L42.7303 41.4968C42.8805 40.8952 43.4913 40.529 44.0929 40.6792C44.6945 40.8297 45.0607 41.4402 44.9102 42.0418L42.6631 51.0307C42.5127 51.6324 41.9021 51.9986 41.3005 51.8481C40.6989 51.6976 40.3327 51.0871 40.4829 50.4855ZM37.3391 42.1737L34.53 45.5445C34.1827 45.9611 34.1827 46.5665 34.53 46.9832L37.3391 50.3539C37.736 50.8302 38.445 50.8946 38.9215 50.4977C39.398 50.1007 39.4624 49.3915 39.0655 48.9153L36.8559 46.2637L39.0655 43.6124C39.4624 43.1359 39.398 42.4269 38.9215 42.0297C38.445 41.6328 37.736 41.6972 37.3391 42.1737ZM46.3286 43.6124L48.5382 46.2637L46.3286 48.9153C45.9316 49.3915 45.9961 50.1007 46.4726 50.4977C46.9488 50.8946 47.658 50.8302 48.0549 50.3539L50.864 46.9832C51.2111 46.5665 51.2111 45.9611 50.864 45.5445L48.0549 42.1737C47.658 41.6972 46.9488 41.6328 46.4726 42.0297C45.9961 42.4269 45.9316 43.1359 46.3286 43.6124Z",
    fill: "url(#paint4_linear_113_4109)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_113_4109",
    x1: 42.4396,
    y1: 11,
    x2: 42.4396,
    y2: 62.0162,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BAE9DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B2F9C4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_113_4109",
    x1: 27.66,
    y1: 10.4543,
    x2: 40.2071,
    y2: 61.991,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BAEBDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3DFC0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_113_4109",
    x1: 27.5273,
    y1: 43.4236,
    x2: 57.8644,
    y2: 43.4236,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF9EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDF78"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_113_4109",
    x1: 27.4993,
    y1: 35.5,
    x2: 32.4321,
    y2: 24.58,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDB6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EA5F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_113_4109",
    x1: 45.0449,
    y1: 45.5,
    x2: 40.9632,
    y2: 46.9179,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#255D70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#21B892"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocs);
export default __webpack_public_path__ + "static/media/docs.344af7ddbd8487c997b72e52e7cda54b.svg";
export { ForwardRef as ReactComponent };